


























import Vue from 'vue'

// Currently loaded script
// import { addUserSettings } from '../scripts/210514_userSettings'
import {functions} from '../services/firebaseAdapter'

export default Vue.extend({
  name: "SuperAdmin",
  data(){
    return {
      newOrganizationId: '',
      createdOrganizationId: '',
      isCreatingOrganization: false,
      hasCreatedOrganization: false,
      // script: addUserSettings
    }
  },
  computed: {},
  methods: {
    async handleScript(script: Function){
      console.log("EXECUTE", script)
      await script()
    },
    async handleCreateOrganization(e: Event){
      e.preventDefault()

      if(
        confirm('Are you sure you want to create an organization with the ID ' + this.newOrganizationId)
      ){
        this.isCreatingOrganization = true
        
        await functions.creatOrganizationAsSuperAdmin(this.newOrganizationId).then(() => {
          this.createdOrganizationId = this.newOrganizationId
          this.newOrganizationId = ''
          this.hasCreatedOrganization = true
        }).catch((error) => {
          alert('The organization coule not be created. This is the error message: ' + error.message)
          console.error('ERROR Creating an organization', error.code, error.message)
          console.error(error.details)
        })

        this.isCreatingOrganization = false
      }else{
        this.newOrganizationId = ''
      }
      
    }
  }
})
